import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

// crf
import crfPageReducer from './crf';
import Drawer from './Drawer';

// Common Routes
import LoginPage from './LoginPage';

// Location Management
import LocationListPage from './LocationListPage';
import LocationDetailPageBasicPage from './LocationDetailPage/BasicPage';

// Equipment
import EquipmentListPage from './EquipmentListPage';
import EquipmentDetailPageBasicPage from './EquipmentDetailPage/BasicPage';
import EquipmentUsageHistoryPage from './EquipmentDetailPage/EquipmentUsageHistoryPage';

// API
import ApiKeyListPage from './ApiKeyListPage';
import ApiKeyDetailPageBasicPage from './ApiKeyDetailPage/BasicPage';

// Admin
import AdminListPage from './AdminListPage';
import AdminDetailPageBasicPage from './AdminDetailPage/BasicPage';

//REPORT
import ReportListPage from './ReportListPage';

export default history =>
	combineReducers({
		form: formReducer,
		router: connectRouter(history),
		drawerReducer: Drawer,
		loginPageReducer: LoginPage,
		// general
		crfPageReducer: crfPageReducer,
		// Equipment Overview
		equipmentOverviewListPageReducer: EquipmentListPage,
		// Location Management
		locationListPageReducer: LocationListPage,
		locationDetailPage: combineReducers({
			basicPageReducer: LocationDetailPageBasicPage
 		}),
		// Equipment Management
		equipmentListPageReducer: EquipmentListPage,
		equipmentDetailPage: combineReducers({
			basicPageReducer: EquipmentDetailPageBasicPage,
			equipmentUsageHistoryReducer: EquipmentUsageHistoryPage
		}),
		// Equipment Controller Status
		equipmentControllerStatusListPageReducer: EquipmentListPage,
		// API key Management
		apiKeyListPageReducer: ApiKeyListPage,
		apiKeyDetailPage: combineReducers({
			basicPageReducer: ApiKeyDetailPageBasicPage
		}),
		// Admin Management
		adminListPageReducer: AdminListPage,
		adminDetailPage: combineReducers({
			basicPageReducer: AdminDetailPageBasicPage
		}),
		// download report
		reportListPageReducer: ReportListPage
	});
